import { render, staticRenderFns } from "./indexOwnerRoom.vue?vue&type=template&id=925a96aa&scoped=true"
import script from "./indexOwnerRoom.vue?vue&type=script&lang=js"
export * from "./indexOwnerRoom.vue?vue&type=script&lang=js"
import style0 from "./indexOwnerRoom.vue?vue&type=style&index=0&id=925a96aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "925a96aa",
  null
  
)

export default component.exports